<template>
  <v-app>
    <div class="login-container">
      <div class="mb-10 logo-container">
        <v-img v-if="setup" :src="setup.picture" max-width="260px" />
      </div>
      <sign-up-form :init="true" />
    </div>

    <primeit-message-snackbar />
  </v-app>
</template>
<script>
import SignUpForm from './default/sign-up.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'SignUp',
  components: {
    SignUpForm,
  },
  computed: {
    ...mapGetters({
      setup: 'credential/SETUP',
    }),
    isAllowedToRegister() {
      return this.setup?.settings?.allow_patient_to_register;
    },
  },
  beforeMount() {
    if (!this.isAllowedToRegister) this.closeMe();
  },
  methods: {
    closeMe() {
      window.location.replace('/');
      window.close();
    },
  },
  created() {
    const vm = this;
    vm.$root.$on('person-sign-close', (val) => vm.closeMe());
  },
};
</script>
